<div *ngIf="displayConfirmationDialog">
    <app-hardcopy-activity-confirmation-modal [hardcopyActivityId]="completeHardcopyActivityId" [removedCopiesMax]="maxDefaultCopies"
        [removeActivity]="isRemoveActivity" [closeConfirmationModalVisible]="isConfirmationModalVisible" (closeConfirmationModal)="handleConfirmation($event)">
    </app-hardcopy-activity-confirmation-modal>
</div>
<div *ngIf="displayRemoveCopiesDialog">
    <app-delete-hard-copy [hardcopyActivityId]="completeHardcopyActivityId" [closeDeleteModalVisible]="isDeleteModalVisible" (closeDeleteModal)="handleDeleteModal($event)" >
    </app-delete-hard-copy>
</div>
<div>
    <p-button appPreventDoubleClick *ngIf="addHardCopyButton" title="Add Hardcopy Activity" pTooltip="Add Hardcopy Activity" tooltipPosition="left" icon="fa fa-plus" id="addDocumentButton"
        class="add-hardCopy-activity-button" iconPos="left" (debounceClick)="openHardCopyActivitySlider()"></p-button>
</div>
<div class="hardCopyPanelList">

        <app-panel-list *ngIf = "!showLoader" [panelList]="hardCopydata" [noResultFound] = "!ispanelListDataAvailable">
            <ng-template #templateRef let-data="dataVar">
                <div panel-content>
                    <div class="grid">
                        <div class="col1">
                            <div class="fields-row">
                        <div class="col4">
                            <app-label labelText="{{ 'Activity'}}"></app-label>
                            <app-read-only readonlyText="{{data?.activity}}"></app-read-only>
                        </div>
                        <div class="col4 overflow-ellipsis">
                            <app-label labelText="{{ 'Assigned User'}}"></app-label>
                            <div class="text-container overflow-ellipsis">
                                <app-read-only [ngClass]="{'inActiveGroup':data?.assignedUser.isActive===false || data?.assignedUser.isTerminated===true}" readonlyText="{{ data?.assignedUser.assignedUserName }}" toolTipMessage="{{ data?.assignedUser.assignedUserName }}"></app-read-only>
                            </div>
                        </div>
                        <div class="col4 notesCol overflow-ellipsis">
                            <app-label labelText="{{ 'eQMS Scope'}}"></app-label>
                            <div class="text-container overflow-ellipsis">
                                <app-read-only readonlyText="{{data?.eQMSScopeName }}"
                                    toolTipMessage="{{data?.eQMSScopeName}}"></app-read-only>
                            </div>
                        </div>
                    </div>
                    <div class="fields-row">
                        <div class="col4">
                            <app-label labelText="{{ 'Status'}}"></app-label>
                            <div class="grid pt-1">
                                <div class="col max-w-0 ml-1">
                                    <em class="pi pi-circle-fill pt-1"
                                    [ngClass]="{ 'scheduled' : data?.status == 'Scheduled', 'pending' : 
                                    data?.status == 'Pending',  'done' : data?.status == 'Done'}"></em>
                                </div>
                                <div class="col max-w-6rem ml-2">
                                    <app-read-only readonlyText="{{data?.status}}"></app-read-only>
                                </div>
                                <div class="col">
                                </div>
                            </div>
                        </div>
                        <div class="col4">
                            <div class="col5">
                                <app-label labelText="{{ 'Copies'}}"></app-label>
                                <app-read-only readonlyText="{{ data?.copies}}"></app-read-only>
                            
                            </div>
                            <div class="col5" *ngIf="data?.activity == 'Remove' && data?.status =='Done' ">
                                <app-label labelText="{{ 'Removed Copies'}}"></app-label>
                                <app-read-only readonlyText="{{ data?.removedCopies}}"></app-read-only>
                            </div>
                        </div>
                        

                        <div class="col4">
                            <app-label labelText="{{ 'Hardcopy Storage Location'}}"></app-label>
                            <app-read-only readonlyText="{{data?.hardcopyStorageLocation}}"></app-read-only>
                        </div>
                    </div>
                    </div>
                        <div class="col2">
                            <app-label labelText="{{ 'Notes' }}"></app-label>
                            <app-read-only readonlyText="{{data?.notes}}"></app-read-only>
                        </div>
                        <div class="col3">
                            <div class="col6">
                              <app-speed-dial [menuItemsData]="setData(data)"> </app-speed-dial>
                            </div>
                          </div>
                    </div>
                </div>
            </ng-template>

        </app-panel-list>


</div>
<app-hard-copy-activity [documentNumber]="documentNumber"
    [isCreateHardCopyActivitySliderOpen]="isHardCopyActivitySliderOpen" [documentVersion]="documentVersion" [activityId]="dataActivityId" 
    [(showRemovedCopies)]="showRemovedCopiesChange"
    [documentStatus]="documentStatus" (closeHardCopyActivitySlider)="closeSliderOnConfiramtion($event)">
</app-hard-copy-activity>
<app-hardcopyactivity-audit-modal *ngIf="showHardCopyActivityModal"
[hardCopyActivityId]="hardCopyActivityIdForAudit"
[isHardCopyActivityAuditModalShow]="showHardCopyActivityModal"
(showHardCopyActivityAuditModal)="closeHardCopyActivityAuditModal($event)">
</app-hardcopyactivity-audit-modal>
